module.exports = __webpack_public_path__ + "img/why-salem-low-percentage.d3062aee.svg";